import React from 'react';
import { Form, Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import BusinessUnitsSection from '@rd-web-markets/shared/dist/technicalProof/BusinessUnitsSection';
import { fields_of_science_and_technology } from './fields_of_science_and_technology';
import { FormattedNumberInput } from '@rd-web-markets/shared/dist/util';
import { createFilter } from 'react-select';
import ProjectSubsidiaryCompanies from './ProjectSubsidiaryCompanies';
import ProjectComments from './ProjectComments';
import ThemeSection from '@rd-web-markets/shared/dist/technicalProof/ThemeSection';
import ImmutableUnderReviewFormControl from '@rd-web-markets/shared/dist/util/reviewEditControls/ImmutableUnderReviewFormControl';
import ChangeHighlightedImmutableUnderReviewControl from '@rd-web-markets/shared/dist/util/reviewEditControls/ChangeHighlightedImmutableUnderReviewControl';
import ImmutableUnderReviewSelect from '@rd-web-markets/shared/dist/util/reviewEditControls/ImmutableUnderReviewSelect';
import RndProjectDates from './RndProjectDates';
import RndTrialsRelatedFields from './RndTrialsRelatedFields';
import DropdownFormField from '@rd-web-markets/shared/dist/util/form/DropdownFormField';
const SummarySection = _ref => {
  let {
    handleChange,
    report,
    company,
    toggleOngoing,
    isOngoing,
    setReport,
    claimGroup,
    handleSubmit,
    handleDateChange,
    pageAccess,
    isUnderReview,
    reportNotesHandlers
  } = _ref;
  const {
    t
  } = useTranslation();
  const selectableProjectCostMethodologies = [claimGroup.is_using_sampling_cost_methodology ? ['project_methodology_sampling_sample', 'project_methodology_sampling_extrapolated', 'project_methodology_sampling_excluded', 'project_methodology_sampling_nominated'] : [], claimGroup.is_using_shortlisting_cost_methodology ? ['project_methodology_shortlisting_shortlisted', 'project_methodology_shortlisting_not_shortlisted'] : [], claimGroup.is_using_rag_cost_methodology ? ['project_methodology_rag_red', 'project_methodology_rag_amber', 'project_methodology_rag_green'] : []].flatMap(x => x);
  const sortByLabel = list => {
    return list.sort((elA, elB) => {
      if (elA.label > elB.label) return 1;else if (elA.label < elB.label) return -1;
      return 0;
    });
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(RndProjectDates, {
    report: report,
    isUnderReview: isUnderReview,
    pageAccess: pageAccess,
    isOngoing: isOngoing,
    handleDateChange: handleDateChange,
    handleSubmit: handleSubmit,
    toggleOngoing: toggleOngoing
  }), (company === null || company === void 0 ? void 0 : company.has_subsidiary_companies) && /*#__PURE__*/React.createElement(ProjectSubsidiaryCompanies, {
    claimGroup: claimGroup,
    report: report,
    pageAccess: pageAccess,
    isUnderReview: isUnderReview,
    handleSubmit: handleSubmit,
    handleChange: handleChange
  }), /*#__PURE__*/React.createElement(Form.Group, {
    className: "mb-2",
    as: Row
  }, /*#__PURE__*/React.createElement(Form.Label, {
    column: "md",
    md: 4
  }, t('project_category')), /*#__PURE__*/React.createElement(Col, {
    md: 4
  }, /*#__PURE__*/React.createElement(ImmutableUnderReviewFormControl, {
    disabled: !pageAccess.canEditProjectDetails || report.assessment !== 'completed' || report.completion_status !== 'finished' || isUnderReview,
    as: "select",
    name: "category",
    onBlur: handleSubmit,
    onChange: handleChange,
    size: "md",
    value: report.category || 'tbc'
  }, /*#__PURE__*/React.createElement("option", {
    value: "rnd"
  }, t('r&d')), /*#__PURE__*/React.createElement("option", {
    value: "non_rnd"
  }, t('non_r&d')), /*#__PURE__*/React.createElement("option", {
    value: "tbc"
  }, t('tbc'))))), /*#__PURE__*/React.createElement(Form.Group, {
    className: "mb-2",
    as: Row
  }, /*#__PURE__*/React.createElement(Form.Label, {
    column: "md",
    md: 4
  }, t('escalation_required')), /*#__PURE__*/React.createElement(Col, {
    md: 4
  }, /*#__PURE__*/React.createElement(ImmutableUnderReviewFormControl, {
    disabled: !pageAccess.canEditProjectDetails || isUnderReview,
    as: "select",
    name: "escalation_required",
    onBlur: handleSubmit,
    onChange: handleChange,
    size: "md",
    value: report.escalation_required
  }, /*#__PURE__*/React.createElement("option", {
    value: true
  }, "Yes"), /*#__PURE__*/React.createElement("option", {
    value: false
  }, "No")))), /*#__PURE__*/React.createElement(BusinessUnitsSection, {
    report: report,
    isUnderReview: isUnderReview,
    claimGroup: claimGroup,
    setReport: setReport,
    pageAccess: pageAccess
  }), /*#__PURE__*/React.createElement(ThemeSection, {
    report: report,
    isUnderReview: isUnderReview,
    claimGroup: claimGroup,
    setReport: setReport,
    pageAccess: pageAccess
  }), /*#__PURE__*/React.createElement(Form.Group, {
    className: "mb-2",
    as: Row
  }, /*#__PURE__*/React.createElement(Form.Label, {
    column: "md",
    md: 4
  }, t('field_of_science_or_technology')), /*#__PURE__*/React.createElement(Col, {
    md: 4
  }, /*#__PURE__*/React.createElement(ChangeHighlightedImmutableUnderReviewControl, {
    as: Form.Control,
    onChange: handleChange,
    onBlur: handleSubmit,
    name: "field_of_science_and_technology",
    object: report,
    size: "md",
    type: "text",
    disabled: !pageAccess.canEditProjectDetails || isUnderReview
  }))), /*#__PURE__*/React.createElement(DropdownFormField, {
    label: "select_project_cost_methodology_type",
    values: selectableProjectCostMethodologies,
    onChange: value => handleChange({
      target: {
        name: 'cost_methodology_type',
        type: 'select',
        value
      }
    }),
    onBlur: handleSubmit,
    valueAttributeName: 'id',
    textAttributeName: 'name',
    disabled: !pageAccess.canEditProjectDetails || isUnderReview,
    value: report.cost_methodology_type,
    labelMd: 4,
    fieldMd: 4
  }), /*#__PURE__*/React.createElement(RndTrialsRelatedFields, {
    report: report,
    handleChange: handleChange,
    handleSubmit: handleSubmit,
    disabled: !pageAccess.canEditProjectDetails || isUnderReview
  }), /*#__PURE__*/React.createElement(Form.Group, {
    className: "mb-2",
    as: Row
  }, /*#__PURE__*/React.createElement(Form.Label, {
    column: "md",
    md: 4
  }, t('total_cost')), /*#__PURE__*/React.createElement(Col, {
    md: 4
  }, /*#__PURE__*/React.createElement(ChangeHighlightedImmutableUnderReviewControl, {
    disabled: !pageAccess.canEditProjectDetails || isUnderReview,
    as: FormattedNumberInput,
    onChange: handleChange,
    onBlur: handleSubmit,
    name: "total_cost",
    object: report,
    size: "md",
    type: "text",
    min: 0
  }))), /*#__PURE__*/React.createElement(Form.Group, {
    className: "mb-2",
    as: Row
  }, /*#__PURE__*/React.createElement(Form.Label, {
    column: "md",
    md: 4
  }, t('total_qe')), /*#__PURE__*/React.createElement(Col, {
    md: 4
  }, /*#__PURE__*/React.createElement(ChangeHighlightedImmutableUnderReviewControl, {
    disabled: !pageAccess.canEditProjectDetails || isUnderReview,
    as: FormattedNumberInput,
    onChange: handleChange,
    onBlur: handleSubmit,
    name: "total_qe",
    object: report,
    size: "md",
    type: "text",
    min: 0
  }))), /*#__PURE__*/React.createElement(Form.Group, {
    className: "mb-2",
    as: Row
  }, /*#__PURE__*/React.createElement(Form.Label, {
    column: "md",
    md: 4
  }, t('r&d'), " %"), /*#__PURE__*/React.createElement(Col, {
    md: 4
  }, /*#__PURE__*/React.createElement(ChangeHighlightedImmutableUnderReviewControl, {
    disabled: true,
    as: Form.Control,
    onChange: handleChange,
    onBlur: handleSubmit,
    name: "rnd_percentage",
    object: report,
    size: "md",
    type: "number",
    max: 100,
    min: 0
  }))), /*#__PURE__*/React.createElement(Form.Group, {
    className: "mb-2",
    as: Row
  }, /*#__PURE__*/React.createElement(Form.Label, {
    column: "md",
    md: 4
  }, t('total_r&d_hours')), /*#__PURE__*/React.createElement(Col, {
    md: 4
  }, /*#__PURE__*/React.createElement(ChangeHighlightedImmutableUnderReviewControl, {
    disabled: !pageAccess.canEditProjectDetails || isUnderReview,
    as: FormattedNumberInput,
    decimalScale: 1,
    onChange: handleChange,
    onBlur: handleSubmit,
    name: "total_rnd_hours",
    object: report,
    size: "md",
    type: "text",
    min: 0
  }))), /*#__PURE__*/React.createElement(ProjectComments, {
    report: report,
    reportNotesHandlers: reportNotesHandlers,
    setReport: setReport
  }));
};
export default SummarySection;